import { Button, Form, Offcanvas } from "react-bootstrap";
import { formServices } from "../../../APIServices/VoultManagement/formServices";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

const UpdateFormMeta = ({
  Show,
  Hide,
  Title,
  getFormMetaList,
  formMetadata,
  categoryMetaList
}) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");

  const updatedFormMeta = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update Form metadata?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      const userData = {
        formId: formMetadata?.formId,
        categoryId,
        name,
      };
      const data = await formServices.updatedFormMeta(userData);
      if (data?.statusCode === 200) {
        setName("");
        setCategoryId("");
        getFormMetaList();
        Hide();
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (formMetadata) {
      setName(formMetadata.name || "");
      setCategoryId(formMetadata.categoryId || "");
    }
  }, [formMetadata]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Category
          </Form.Label>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px"}}
            onChange={(e) => setCategoryId(e.target.value)}
            value={categoryId}
          >
            <option value="">Select Category</option>
            {categoryMetaList?.map((item, index) => (
              <option key={index} value={item?.key}>{item?.name}</option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || !categoryId || loader}
          onClick={updatedFormMeta}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Updating..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateFormMeta;
